/* global $, window, document */

define(['jquery'], $ => {
    const $document = $(document);
    const $window = $(window);
    const $body = $(document.body);
    const $html = $('html');

    return { $document, $window, $body, $html };
});
